import React from "react";
import "./About.css";

function About() {
    return (
        <>
            <h2 className="abt-header">About me</h2>
            <div className="about-container -c">
                <p>
                    I'm a dedicated, outgoing software engineer. I have a
                    passion for everything programming and design related,
                    that's why I usually combine both of them in my projects. I
                    will finalize my bachelors in computer science next fall at
                    Florida International University. Aside from being a
                    developer, my hobbies are baseball, karting, reading and
                    enjoying challenging FromSoftware video games!
                </p>
            </div>
        </>
    );
}

export default About;
